/**
 * Created by Colin.Watson on 4/1/2015.
 */
/// <reference path="../../app.typings.d.ts" />
(function () {
	'use strict';
	var ApiEndpointProvider = (function () {
		function ApiEndpointProvider() {
		}
		ApiEndpointProvider.prototype.configure = function (baseUrl) {
			this.config = {
				baseUrl: baseUrl
			};
		};
		ApiEndpointProvider.prototype.$get = function () {
			return this.config;
		};
		return ApiEndpointProvider;
	})();
	angular.module('blocks').provider('blocks.ApiEndpoint', ApiEndpointProvider);
})();
